module.exports = __webpack_public_path__ + "images/image_fullscreen_in_bf7caf9d4d42d291a8399a657051d573.svg";